import React from "react";
import { QRCode } from "react-qrcode-logo";

const CustomQRCode = ({ value, logo }) => {
  return (
    <QRCode
      value={value}
      logoImage={logo}
      logoWidth={90}
      logoHeight={90}
      qrStyle={{ width: 150 }}
    />
  );
};
export default CustomQRCode;
